export const CTAActionTypesEnum = Object.freeze({
  CALL: 'CALL',
  LINK: 'LINK',
  EMAIL: 'EMAIL',
  WHATSAPP: 'WHATSAPP',
});
